// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2005":"f8e77377bbdbf68a","4736":"73aba23c8d0cd0a6","8745":"ec6b7ec081bdd30b"}[chunkId] + ".js";
};